<template>
  <v-card height="600">
    <v-card-title class="headline font-weight-thin">Batch Edit Confirmation</v-card-title>
    <v-card-text v-if="!secondarySelectedFieldDisplayText">
      Are you sure you want to update the following
      <span class="font-weight-bold">{{ selectedItems.length }}</span> records with
      <span class="font-weight-bold"> {{ selectedFieldDisplayText }} </span> set to
      <span class="font-weight-bold"> {{ selectedValue }}? </span>
    </v-card-text>
    <v-card-text v-else>
      Are you sure you want to update the following
      <span class="font-weight-bold">{{ selectedItems.length }}</span> records with
      <span class="font-weight-bold"> {{ selectedFieldDisplayText }} </span> set to
      <span class="font-weight-bold"> {{ selectedValue }}</span> and
      <span class="font-weight-bold">{{ secondarySelectedFieldDisplayText }}</span> set to
      <span class="font-weight-bold"> {{ secondarySelectedValue }}? </span>
    </v-card-text>
    <v-card-text>
      <v-data-table
        :headers="computedHeaders"
        :item-key="getItemKey()"
        :items-per-page="10"
        :items="selectedItems"
        class="elevation-0 mt-5"
        dense
      >
        <template
          v-slot:item.primaryActivityDropdownValueId="{ item }"
          v-if="editedField === 'primaryActivityDropdownValueId'"
        >
          <div><strong>Primary Activity: </strong>{{ item.primaryActivity }}</div>
          <div><strong>Application: </strong>{{ item.application }}</div>
        </template>
        <template v-slot:item.selectedValue="{ item }">
          <div v-if="editedField === 'primaryActivityDropdownValueId'">
            <div><strong>Primary Activity: </strong>{{ selectedValue }}</div>
            <div><strong>Application: </strong>{{ secondarySelectedValue }}</div>
          </div>
          <div v-else>{{ selectedValue }}</div>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn @click="cancel" class="mr-2" data-cy="cancelBatchEdit" outlined small>Cancel</v-btn>
      <v-btn
        @click="submit"
        class="elevation-0 font-weight-bold"
        color="primary"
        data-cy="confirmBatchEdit"
        outlined
        small
        >Submit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  computed: {
    computedHeaders() {
      const computedHeaders = [...this.headers];
      if (this.getItemKey() === "id") {
        /* Only display the id if it's a release note list, which has an `id` for the release note record,
        and not a test plan list, which has `releaseNoteId` for the release note record). */
        computedHeaders.unshift({
          text: "ID",
          value: this.getItemKey(),
        });
      }

      computedHeaders.push({
        text: "New Value",
        value: "selectedValue",
      });
      return computedHeaders;
    },
  },
  data() {
    return {
      headers: [{ text: "Title", value: "title" }, { text: "Current Value", value: this.editedField }],
    };
  },
  methods: {
    cancel() {
      this.$emit("cancelBatchEdit");
      this.$emit("setDialog", false);
    },
    getItemKey() {
      return this.$route.name === "releaseNoteList" || this.$route.name === "search" ? "id" : "releaseNoteId";
    },
    async submit() {
      this.$emit("submitBatchEdit");
      this.$emit("setDialog", false);
    },
  },
  props: {
    editedField: { required: true },
    selectedFieldDisplayText: { required: true },
    selectedValue: { required: true },
    selectedItems: { required: true },
    secondarySelectedFieldDisplayText: { required: false },
    secondarySelectedValue: { required: false },
  },
};
</script>
